var React = require('react');

function AppleOpaque (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.354 16.487c-1.338-.506-2.233-1.72-2.334-3.17-.099-1.412.593-2.666 1.851-3.355l1.046-.573-.747-.93c-1.255-1.563-3.05-2.497-4.804-2.497-1.215 0-2.058.318-2.735.574-.478.181-.855.323-1.269.323-.472 0-.938-.166-1.478-.358-.708-.252-1.51-.538-2.54-.538-1.99 0-3.997 1.188-5.237 3.098-1.85 2.85-1.343 7.734 1.208 11.616C5.326 22.215 6.743 23.982 8.75 24h.04c1.642 0 2.002-.876 3.597-.886 1.742.082 1.962.893 3.59.882 1.96-.018 3.374-1.77 4.498-3.484.664-1.007.921-1.534 1.438-2.678l.438-.97-.997-.377ZM15.1 3.45c.65-.834 1.143-2.01.964-3.214-1.062.073-2.302.748-3.027 1.628-.658.8-1.2 1.983-.99 3.135 1.158.036 2.357-.656 3.053-1.549Z","fill":"#E8EFFF","fillOpacity":".7"}));
}

AppleOpaque.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = AppleOpaque;

AppleOpaque.default = AppleOpaque;
